
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface JobSkillsFieldProps {
  job: Pick<Job, 'skills'>;
  isEditing: boolean;
  formDataSkills: string;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const JobSkillsField: React.FC<JobSkillsFieldProps> = ({ job, isEditing, formDataSkills, onInputChange }) => {
  return (
    <div className="md:col-span-2">
      <Label htmlFor="skills" className="text-xs font-medium text-muted-foreground">Skills</Label>
      {isEditing ? (
        <Textarea
          id="skills"
          name="skills"
          value={formDataSkills}
          onChange={onInputChange}
          placeholder="e.g. React, Node.js, Python (comma-separated)"
          className="text-sm min-h-[60px]"
        />
      ) : (
        <p>{job.skills?.join(', ') || 'N/A'}</p>
      )}
    </div>
  );
};
